import { 
    IonContent,
    IonRow,
    IonCard,
  } from '@ionic/react';

import '../styles/UserSignInComponent.css';
import '../styles/style.css';

function UserSignInComponent (props){

    return (
        <>
        <IonContent>
                <IonRow
                    className="image-bg"
                >
                <IonCard>
                        {props.children}
                </IonCard>
                </IonRow>
        </IonContent>
        </>
    )
}

export default UserSignInComponent